import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getUnsubscribedEmails(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios.get(`${window.apiBase}/admin/unsubscribedEmails`, config).then(response => {
    return response.data;
  });
}

export function getAllUnsubscribedEmails(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios.get(`${window.apiBase}/admin/unsubscribedEmails`, config).then(response => {
    return response.data;
  });
}

export function getUnsubscribedEmailsCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios.get(`${window.apiBase}/admin/unsubscribedEmails/count`, config).then(response => {
    return response.data;
  });
}

export function addUnsubscribedEmail(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.post(`${window.apiBase}/admin/unsubscribedEmails`, data, config).then(response => {
    return response.data;
  });
}

export function updateUnsubscribedEmail(user: AppUser, unsubscribedEmailId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.put(`${window.apiBase}/admin/unsubscribedEmails/${unsubscribedEmailId}`, data, config).then(response => {
    return response.data;
  });
}

export function deleteUnsubscribedEmail(user: AppUser, unsubscribedEmailId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios.delete(`${window.apiBase}/admin/unsubscribedEmails/${unsubscribedEmailId}`, config).then(response => {
    return response.data;
  });
}
